import { Typography, Box, Button, styled, Fade, Paper } from '@mui/material';
import ErrorIcon from '@acorn-portal/shared/src/assets/shared/icons/base/broken-down-car.svg?react';
import { Link } from 'react-router';
import CallIcon from '@mui/icons-material/Call';
import { CARROT_CONTACT_NUMBER } from '@acorn-portal/shared/src/utils/constants';

const ImageWrapper = styled('div')(({ theme }) => ({
	'& svg': {
		height: 'auto',
		width: '20em',
		[theme.breakpoints.down('md')]: {
			maxWidth: '220px',
		},
	},
}));

const ServiceUnavailable = () => {
	return (
		<Fade in>
			<Box
				sx={(theme) => ({
					[theme.breakpoints.up('md')]: {
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						minHeight: '100vh',
					},
				})}
			>
				<Paper
					sx={{
						p: 2,
						py: 4,
						display: 'flex',
						flex: 1,
						flexDirection: 'column',
						alignItems: 'center',
					}}
				>
					<Typography
						variant='h4'
						sx={(theme) => ({
							[theme.breakpoints.down('md')]: {
								fontSize: '2rem',
							},
						})}
						color='secondary'
						gutterBottom
						textAlign='center'
					>
						Scheduled Maintenance Underway
					</Typography>
					<ImageWrapper>
						<ErrorIcon />
					</ImageWrapper>
					<Typography
						sx={(theme) => ({
							[theme.breakpoints.down('md')]: {
								fontSize: '1rem',
							},
						})}
						variant='h5'
						color='secondary'
						gutterBottom
						textAlign='left'
					>
						Thanks for visiting the Carrot Customer Portal! We&apos;re taking a brief pause for scheduled maintenance to
						provide an even better experience for you. If you need assistance in the meantime, our customer service team
						is here to help at{' '}
						<Link to={`tel:${CARROT_CONTACT_NUMBER}`} reloadDocument>
							{CARROT_CONTACT_NUMBER}
						</Link>{' '}
						. We appreciate your patience and will be back online soon.{' '}
					</Typography>
					<Button
						href={`tel:${CARROT_CONTACT_NUMBER}`}
						variant='contained'
						color='primary'
						sx={{ mt: 2, minWidth: '40%' }}
						endIcon={<CallIcon />}
					>
						Call Now
					</Button>
				</Paper>
			</Box>
		</Fade>
	);
};

export default ServiceUnavailable;
